import React, { useEffect, useState, memo } from 'react'
import Tab from '@mui/material/Tab'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import Box from '@mui/material/Box'
import Timeline from '@mui/lab/Timeline'
import TimelineItem from '@mui/lab/TimelineItem'
import TimelineSeparator from '@mui/lab/TimelineSeparator'
import TimelineConnector from '@mui/lab/TimelineConnector'
import TimelineContent from '@mui/lab/TimelineContent'
import TimelineDot from '@mui/lab/TimelineDot'
import Typography from '@mui/material/Typography'
import Image from 'next/image'
import clsx from 'clsx'
import { Button, Divider } from '@mui/material'
import sx from './styles'

const TimelineTabs = (props) => {
  const {
    tabs, handleClickLink, handleModal, withBulletsConnector = true,
  } = props
  const [value, setValue] = useState('0')
  const [distance, setDistance] = useState({})
  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  const icon = (item, title) => {
    const { url } = item
    return (
      <Image
        src={url}
        width={32}
        height={32}
        alt={title}
      />
    )
  }

  const updateDistance = () => {
    const lastDotOne = document.getElementById('dot-principal-0')?.getBoundingClientRect().top
    const lastDotClassName = document.getElementById('Timeline-Item')?.getBoundingClientRect().height
    const lastDotChildOne = document.getElementById('dot-secondary-0')?.getBoundingClientRect().top
    const lastDotTwo = document.getElementById('dot-principal-1')?.getBoundingClientRect().top
    const lastDotChildTwo = document.getElementById('dot-secondary-1')?.getBoundingClientRect().top

    setDistance({
      first: lastDotChildOne - lastDotOne - 5,
      second: lastDotChildTwo - lastDotTwo - 5,
      firstTest: lastDotClassName * 2,
    })
  }

  useEffect(() => {
    setTimeout(() => {
      updateDistance()
    }, 300)
  }, [])

  useEffect(() => {
    updateDistance()
  }, [value])

  const timelineItemSecondary = (items, tab, isFinaly) => items.map((item, key) => (
    <TimelineItem
      sx={sx.timelineItem}
      key={key}
    >
      {withBulletsConnector && items.length && items.length > 0 && (
        <TimelineSeparator sx={sx.timelineSeparatorSecondary}>
          <TimelineDot
            sx={sx.timelineDot}
            id={`dot-${items.length === key + 1 && isFinaly ? 'secondary' : key}-${tab}`}
          />
          <TimelineConnector />
        </TimelineSeparator>
      )}
      <TimelineContent id="Timeline-Item">
        <Box
          ml={1}
        >
          <Box sx={sx.titleIcon}>
            {item.icon && (icon(item.icon, item.title))}
            {item.icon_text && (
              <Typography variant="body2">
                {item.icon_text}
              </Typography>
            )}
          </Box>
          <Typography
            variant="subtitle1"
            fontWeight={600}
            mt={1}
          >
            {item.title}
          </Typography>
          {item.description && (
            <Typography
              variant="body1"
              mt={1}
              mb={1}
            >
              {item.description}
            </Typography>
          )}
          {item.cta_text_button && (
            <Typography
              variant="link-text"
              onClick={
                () => (withBulletsConnector
                  ? handleClickLink(item.cta_button)
                  : handleModal(item))
              }
            >
              {item.cta_text_button}
            </Typography>
          )}

        </Box>
      </TimelineContent>
    </TimelineItem>
  ))

  const firstTimelineContent = (item) => (
    <>
      {withBulletsConnector
        ? (
          <Box>
            {icon(item.icon)}
            <Typography
              variant="subtitle1"
              fontWeight={600}
            >
              {item.title}
            </Typography>

            {item.description && (
              <Typography
                variant="body1"
                mt={1}
              >
                {item.description}
              </Typography>
            )}
            <Typography
              variant="link-text"
              onClick={
                () => (withBulletsConnector
                  ? handleClickLink(item.cta_button)
                  : handleModal(item))
              }
            >
              {item.cta_button_text}
            </Typography>
          </Box>
        )
        : (
          <>
            <Box
              style={{ flexDirection: item?.is_divider ? 'row' : 'column', width: '100%' }}
            >
              {item?.is_divider && (
                <Divider
                  py={2}
                  width="100%"
                />
              )}
              <Box
                style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
                mb={3}
              >
                {item.icon && (
                  <Box
                    minWidth="30px"
                  >
                    {icon(item.icon)}
                  </Box>
                )}
                <Box
                  ml={1}
                  sx={sx.itemBox}
                >
                  <Typography
                    variant="body1"
                  >
                    {item.title}
                  </Typography>

                  {item.description && (
                    <Typography
                      variant="link"
                      mt={1}
                      mb={2}
                    >
                      {item.description}
                    </Typography>
                  )}

                  <Typography
                    mt={1}
                    variant="link-text"
                    onClick={
                      () => (withBulletsConnector
                        ? handleClickLink(item.cta_button)
                        : handleModal(item))
                    }
                  >
                    {item.cta_button_text}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </>
        )}
    </>
  )

  const timelineItemPrincipal = (items, tab) => items.map((item, i) => (
    <TimelineItem
      sx={sx.timelineItem}
      key={i}
      className={clsx({
        withoutBullet: !withBulletsConnector,
      })}
    >
      {withBulletsConnector && items && items.length > 0 && (
        <TimelineSeparator>
          <TimelineDot
            sx={sx.timelineDot}
            id={`dot-${items.length === i + 1 ? 'principal' : i}-${tab}`}
          />
          {(items.length !== i + 1 || item.items.length > 0)
            && (
              <TimelineConnector
                sx={items.length === i + 1 && item.items.length > 0
                  ? { height: tab === 0 ? distance?.first : distance?.second, flexGrow: '0' }
                  : { height: tab === 0 ? distance?.firstTest : 630 }}
              />
            )}
        </TimelineSeparator>
      )}

      <TimelineContent
        sx={sx.timelineContent}
      >
        <Box>
          {firstTimelineContent(item)}
        </Box>
        {item?.items && (
          <Timeline sx={sx.timelineRoot}>
            {timelineItemSecondary(item.items, tab, items.length === i + 1)}
          </Timeline>
        )}
      </TimelineContent>
    </TimelineItem>
  ))

  return (
    <TabContext value={value}>
      <Box>
        <TabList
          onChange={handleChange}
          sx={sx.tabList}
        >
          {tabs.map((item, i) => (
            <Tab
              label={item.title}
              value={`${i}`}
              key={i}
              sx={sx.tab}
            />
          ))}
        </TabList>
      </Box>
      {tabs.map((item, i) => (
        <TabPanel
          value={`${i}`}
          key={i}
          sx={sx.tabPanel}
          className={clsx({ border: !withBulletsConnector })}
        >
          <Timeline
            sx={sx.timelineRoot}
          >
            {item.timeline && timelineItemPrincipal(item.timeline, i)}
            {item.disclaimer && (
              <Box sx={sx.disclaimerContainer}>
                <Typography
                  sx={sx.disclaimer}
                  variant="body2"
                >
                  {item.disclaimer}
                </Typography>
              </Box>
            )}
            {item.pdf_title && (
              <Button
                variant="outlined"
                fullWidth
              >
                <a
                  href={`${item.pdf_url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: 'none', color: '#1D2932' }}
                >
                  <Typography
                    variant="subtitle"
                  >
                    {item.pdf_title}
                  </Typography>
                </a>
              </Button>
            )}

          </Timeline>
        </TabPanel>
      ))}
    </TabContext>
  )
}

export default memo(TimelineTabs)
